import { FormattedMessage, useIntl } from "react-intl";
import { MessageBar, MessageBarType } from "@fluentui/react";
import { LineClampedText, useTheme } from "cayo.ui";
import styled from "styled-components";
import { actionHandlers } from "@cayo/shared/scheme/actions";
import { GradientButton } from "../gradientButton";
import { freemiumMessages } from "../messages";

export const RestrictionBanner = () => {
  const intl = useIntl();
  const { cayoTheme } = useTheme();

  return (
    <MessageBar
      messageBarType={MessageBarType.info}
      truncated={true}
      styles={{
        root: {
          margin: "10px 0 10px 0",
          background: cayoTheme.wizard.colors.active,
        },
        icon: {
          display: "none",
        },
        innerText: {
          width: "100%",
        },
      }}
    >
      <Box>
        <Text>
          <FormattedMessage
            {...freemiumMessages.chRestriction}
            values={{
              learnMore: (
                <a
                  href={"https://www.cayosoft.com/products/guardian"}
                  target="_blank"
                  rel="noreferrer"
                >
                  <FormattedMessage {...freemiumMessages.learnMore} />
                </a>
              ),
            }}
          />
        </Text>
        <FixedButtonWrapper>
          <GradientButton
            text={intl.formatMessage(freemiumMessages.upgrade)}
            icon="favoriteStar"
            onClick={() => actionHandlers["show.wizard"]("product-activation,reloadAfterClose")}
          />
        </FixedButtonWrapper>
      </Box>
    </MessageBar>
  );
};

const Box = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

const Text = styled(LineClampedText)`
  font-size: 12px;
  flex: 1 1 auto;
  text-overflow: ellipsis;
`;

const FixedButtonWrapper = styled.div`
  flex: 0 0 auto;
`;
